module.exports = __webpack_public_path__ + "static/media/JCB.12304112.png";